import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryList',
  templateUrl: './SalaryList.component.html',
  styleUrls: ['./SalaryList.component.scss']
})
export class SalaryListComponent implements OnInit {
  Filter_title:string=""
  Filter_year:string="1405"
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Salary_Service:SalaryService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Salary:Array<any>=[]


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2228).subscribe(
      data=>{
        this.ReadData_Salary()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    
  }

  ReadData_Salary(){
    this.Procssing=true
    this.Salary_Service.GetRecord(Number(this.Filter_year)).subscribe(
      data=>{
        this.DataList_Salary=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  //#region Salary Form

  Selected_Salary_Year: number= 0
  Selected_Salary_PersonId: number= 0
  Selected_Salary_Person_Fullname: string= ''
  Selected_Salary_Record_Switcher: string = 'List'
  Set_List_Salary_View() {
    this.ReadData_Salary()
    this.Selected_Salary_Record_Switcher= 'List'
  }

  Set_Form_Salary_View_Add() {
    this.Selected_Salary_Year = Number(this.Filter_year)
    this.Selected_Salary_Record_Switcher = 'BaseForm'
  }

  Set_Form_Salary_View_Add2(PersonId:number,PersonFullname:string) {
    this.Selected_Salary_Year = Number(this.Filter_year)
    this.Selected_Salary_PersonId = PersonId
    this.Selected_Salary_Person_Fullname = PersonFullname
    this.Selected_Salary_Record_Switcher = 'PersonForm'
  }

  //#endregion

}
